export default {"src":"/_next/static/media/legalWork_64.615a788c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};